(function(){

    angular.module('tmx-app').controller('geoFenceCtrl', ['resolvedData','menu', '$scope', '$mdDialog', '$state','$mdSidenav',
        'GeofenceService','$mdMedia','tmxUtility','TmxDialogService', 
    
        function GeoFenceCtrl(resolvedData, menu,$scope, $mdDialog, $state, $mdSidenav, GeofenceService, $mdMedia,tmxUtility,TmxDialogService){
 
            var geofenceVM=this;
            geofenceVM.query = "Pjp";
            geofenceVM.gridData = new kendo.data.ObservableArray([]);
            geofenceVM.date = new Date().toJSON();
            geofenceVM.cols = GeofenceService.gridColumn;
            geofenceVM.nav = "SearchSideNav";
            geofenceVM.schema = GeofenceService.schema;
            geofenceVM.cloneColumn = GeofenceService.gridColumn;            
            geofenceVM.GeofenceService = GeofenceService;
            geofenceVM.Locations = resolvedData.Locations.data;
            geofenceVM.checkPermission = tmxUtility.checkPermission;
            geofenceVM.menu=menu;
  
            geofenceVM.editPermission = geofenceVM.checkPermission("Private.Masterdata.GeoFence","Edit");
  //**********functions****************

            geofenceVM.success=function(promise){
                if(promise.read==true) {      
                    for (var j = geofenceVM.container.geofenceGrid.columns.length - 1; j >= 0; j--) {
        
      
                        if(angular.isDefined(geofenceVM.o.data.filter) && geofenceVM.o.data.filter!=null) {
                            if(angular.isDefined(geofenceVM.o.data.filter.filters) && geofenceVM.o.data.filter.filters.length>0) {
                                for (var i = geofenceVM.o.data.filter.filters.length - 1; i >= 0; i--) {
                                    if(geofenceVM.o.data.filter.filters[i].field==geofenceVM.container.geofenceGrid.columns[j].field) {
                                        geofenceVM.container.geofenceGrid.columns[j].headerTemplate="<span>"+geofenceVM.container.geofenceGrid.columns[j].title+"<md-icon >file_download</md-icon></span>";
                                        geofenceVM.container.geofenceGrid.columns[j].title="changed";
                                    }
                                }
                            }
                        } 
                    }
                }                 
            };

            geofenceVM.onChildState=function(){
                if($state.current.name.indexOf(".add")>0 || $state.current.name.indexOf(".edit")>0) return true;
            }  

            geofenceVM.isOpen = function(navID) {
                return $mdSidenav(navID).isOpen();
            };

            geofenceVM.new = function(){
                $state.go($state.current.name+".add");
            };

            geofenceVM.clickEdit = function (item) {  
                $state.data.info = false;          
                $state.go($state.current.name+".edit",{"Id":item.LocationID});
            }

  // $state.data.info = false;

            geofenceVM.clickView = function (item) {   
                $state.data.info = true;         
                $state.go($state.current.name+".edit",{"Id":item.LocationID});
            }            

            geofenceVM.formatGeofenceName=function(dataitem) {
                return  tmxUtility.sliceText(dataitem,25);
            }

            geofenceVM.getGeofenceCode=function(dataitem) {
                if(dataitem!=null && angular.isDefined(dataitem)) {
                    return dataitem;
                }
                return "N/A";
            }

            geofenceVM.geofenceCount=function(dataitem) {
                return  dataitem.GeofenceCount;
            }            

            geofenceVM.isFiltered=function(fieldName){               
                var filtered = false;                
                if(angular.isDefined(geofenceVM.filters)) {
                    geofenceVM.filters.filters.forEach(function(filter){
                        if(filter.field==fieldName)
                            filtered = true;
                    });
                }
                return filtered;
            }    
            
            geofenceVM.isLocationFiltered=function(fieldName){                         
                var filtered = false;                
                if(angular.isDefined(geofenceVM.filters)) {
                    geofenceVM.filters.filters.forEach(function(filter){
                        if(filter.field==fieldName)
                            filtered = true;
                    });
                }
                return filtered;
            }    

//*******************KENDO*********************//  
            // geofenceVM.gridColumns = GeofenceService.columns;

            geofenceVM.mainGridOptions = {
                dataSource: {
            
                    transport: {
                        read: function(o){
                            geofenceVM.searchClear = false;
                            if(geofenceVM.onChildState()){return;}
                            if(!o.fromSideNav) {
                                if($state.searchClear){
                                    geofenceVM.searchClear = true;
                                    $state.searchClear=undefined;                           
                                }                    
                            }
                            else{
                                o.data.firstPage = true;
                            }

                            geofenceVM.o = angular.copy(o);  
                            geofenceVM.filters = geofenceVM.o.data.filter;
                            GeofenceService.getByParams(o,true).then(function(response){
                                parseResppnse(response.data);
                                o.success(response)
                            });
                        },

                        dataType: "json"
                    },
                    schema: {
                        data: "data",
                        total: "Total"
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,                        
                },        
                pageable: {
                    refresh: true,
                    pageSizes: true,
                    pageSize: 10,
                    buttonCount: 5
                },
                pdf: {
                    allPages: true,
                    fileName: "Geofences.pdf"
                },
                excel: {
                    allPages: true,
                    fileName: "Geofences.xlsx"
                },        
                sortable: true,
                scrollable: false,        
                rowTemplate: kendo.template($("#rowTemplate").html()),        
                columns: geofenceVM.cols
            };


//*****************************************
            geofenceVM.container = {};
            $state.data={
                grid: geofenceVM.container,
                info: false

            };


//************for filtering/search************
            geofenceVM.searchSideNavActive=false;
    
            geofenceVM.toggleSearch=function(){
                if(geofenceVM.searchSideNavActive) {
                    geofenceVM.searchData = {};
                    geofenceVM.searchSideNavActive=false;
                }
                else
                    geofenceVM.searchSideNavActive=true;
                geofenceVM.toggle('SearchSideNav');
            }
            geofenceVM.exportSideNavActive=false;

            geofenceVM.toggleExport=function(){
                if(geofenceVM.exportSideNavActive)
                    geofenceVM.exportSideNavActive=false;
                else
                    geofenceVM.exportSideNavActive=true;
                geofenceVM.toggle('ExportSideNav');
            }

            geofenceVM.toggle = function(navID) {
                $mdSidenav(navID)
                    .toggle()
                    .then(function() {
                    });
            };

            geofenceVM.filt = {};
    

            geofenceVM.search = function(navID) {
      
                let calls=[];
  

                for (var key in geofenceVM.searchData) {
                    if (geofenceVM.searchData.hasOwnProperty(key)) {
                        calls.push({
                            field: key,
                            operator: "contains",
                            value: geofenceVM.searchData[key]
                        });
                    }
                }

                geofenceVM.filt = {
                    filters: calls,
                    logic: "and"
                };
                geofenceVM.o.data.filter = geofenceVM.filt;
                geofenceVM.container.geofenceGrid.dataSource.transport.read(geofenceVM.o);

                geofenceVM.searchData = {};
                geofenceVM.toggle(navID);
            };

            geofenceVM.clear = function(navID) {
                geofenceVM.searchData = {};
                geofenceVM.toggle(navID);
            };

            function parseResppnse(data){
                data.forEach(function(dataItem){                                        
                    dataItem.LocationName = geofenceVM.formatGeofenceName(dataItem.LocationName);
                    dataItem.LocationCode = geofenceVM.getGeofenceCode(dataItem.LocationCode);
                });
            }

        }]);
})();